import { Link } from 'react-router-dom'

function getOperator() {
  const name = import.meta.env.VITE_OPERATOR_NAME as string | undefined
  const address = import.meta.env.VITE_OPERATOR_ADDRESS as string | undefined

  return {
    name: name && name.trim().length > 0 ? name.trim() : '[Nom de l’opérateur]',
    address:
      address && address.trim().length > 0 ? address.trim() : '[Adresse postale de l’opérateur]',
  }
}

export default function Terms() {
  const operator = getOperator()

  return (
    <main className="page" style={{ padding: '56px 24px 96px' }}>
      <div style={{ maxWidth: 860, margin: '0 auto' }}>
        <p
          style={{
            margin: 0,
            fontSize: 13,
            letterSpacing: '.14em',
            textTransform: 'uppercase',
            color: 'var(--muted)',
          }}
        >
          Conditions d’utilisation
        </p>
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontStyle: 'italic',
            fontWeight: 400,
            fontSize: 'clamp(34px, 5vw, 56px)',
            lineHeight: 1.08,
            margin: '14px 0 10px',
          }}
        >
          Conditions
        </h1>
        <p
          style={{
            margin: '0 0 28px',
            color: 'color-mix(in oklab, var(--ink) 72%, transparent)',
            fontSize: 17,
          }}
        >
          Ces conditions décrivent les règles minimales d’usage du service “Liste de naissance” dans
          le cadre de la version Spec A.
        </p>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            1. Éditeur du service
          </h2>
          <p style={{ margin: 0 }}>
            Le service est édité par <strong>{operator.name}</strong>, {operator.address}.
          </p>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            2. Description du service
          </h2>
          <p style={{ margin: 0 }}>
            “Liste de naissance” permet de créer une page de liste de cadeaux pour bébé, d’y ajouter
            des objets (avec descriptions, prix, images et liens éventuels) et de la partager via un
            lien. Les invités peuvent contribuer à un objet (montant) ou signaler qu’ils offrent
            l’objet entier.
          </p>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            3. Paiements et contributions
          </h2>
          <p style={{ margin: 0 }}>
            Le service n’encaisse pas les fonds. Les contributions sont effectuées directement via
            les coordonnées indiquées par le propriétaire (IBAN, Lydia, Wero, PayPal…). Aucun frais
            ni commission n’est prélevé par le service dans Spec A.
          </p>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            4. Accès, sécurité, disponibilité
          </h2>
          <ul style={{ margin: '0 0 0 18px', padding: 0 }}>
            <li>Vous êtes responsable de la confidentialité des liens que vous partagez.</li>
            <li>Le service peut être interrompu temporairement pour maintenance.</li>
            <li>
              Nous mettons en œuvre des mesures raisonnables de sécurité, sans garantie d’absence
              totale de risque.
            </li>
          </ul>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            5. Contenu utilisateur
          </h2>
          <p style={{ margin: 0 }}>
            Vous conservez la responsabilité des informations que vous publiez (textes, images,
            liens). Vous vous engagez à ne pas publier de contenu illégal, diffamatoire ou portant
            atteinte aux droits de tiers.
          </p>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            6. Suppression de compte
          </h2>
          <p style={{ margin: 0 }}>
            Vous pouvez supprimer votre compte à tout moment depuis{' '}
            <Link to="/me/account">Mon compte</Link>. Cette action supprime vos données conformément
            à la logique décrite dans la <Link to="/privacy">Politique de confidentialité</Link>.
          </p>
        </section>

        <section style={{ marginTop: 34 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 26,
              margin: '0 0 10px',
            }}
          >
            7. Contact
          </h2>
          <p style={{ margin: 0 }}>
            Contact : <a href="mailto:hello@listedenaissance.app">hello@listedenaissance.app</a>.
          </p>
        </section>

        <hr
          style={{
            border: 0,
            borderTop: '1px solid color-mix(in oklab, var(--ink) 12%, transparent)',
            margin: '44px 0 18px',
          }}
        />
        <p style={{ margin: 0, fontSize: 13, color: 'var(--muted)' }}>
          <Link to="/">Retour à l’accueil</Link> · <Link to="/privacy">Confidentialité</Link>
        </p>
      </div>
    </main>
  )
}
